import GSAP from "gsap";
export default class {
  constructor() {
    this.elements = {
      variant1Btn: document.querySelector(".variant1Btn"),
      variant2Btn: document.querySelector(".variant2Btn"),
      projectWrapperSecond: document.querySelector(".project__wrapper_second"),
    };
  }

  pageVariantMobile() {
    if (
      !this.elements.variant1Btn ||
      !this.elements.variant2Btn ||
      !this.elements.projectWrapperSecond
    )
      return;
    this.elements.variant1Btn.addEventListener("click", () => {
      GSAP.to(this.elements.projectWrapperSecond, {
        opacity: 0,
        duration: 0.3,
        ease: "power2.out",
        onComplete: () => {
          this.elements.projectWrapperSecond.style.pointerEvents = "none";
        },
      });
    });
    this.elements.variant2Btn.addEventListener("click", () => {
      GSAP.to(this.elements.projectWrapperSecond, {
        opacity: 1,
        duration: 0.3,
        ease: "power2.out",
        onComplete: () => {
          this.elements.projectWrapperSecond.style.pointerEvents = "auto";
        },
      });
    });
  }
}
